var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckbox = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#EBEBEB",
  d: "M12 1C5.933 1 1 5.933 1 12s4.933 11 11 11 11-4.933 11-11S18.067 1 12 1Z",
  className: "checkbox_svg__check-circle"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M6.684 12.22a1 1 0 1 0-1.368 1.46zM10.32 17l-.684.73a1 1 0 0 0 1.445-.08zm8.44-8.35a1 1 0 0 0-1.52-1.3zM5.317 13.68l4.32 4.05 1.368-1.46-4.32-4.05zm5.765 3.97 7.68-9-1.522-1.3-7.68 9z",
  className: "checkbox_svg__checkmark"
})));
export { SvgCheckbox as ReactComponent };